// extracted by mini-css-extract-plugin
module.exports = {"studentDetails":"student-details_studentDetails__2TY_R","meta":"student-details_meta__16Djd","in":"student-details_in__TGE0g","out":"student-details_out__26Wyl"};